import { FieldSelect } from "@knowtex-ai/components";
import type { ReactElement } from "react";
import { formatMicrophoneLabel, type MicrophoneOption } from "./recorderUiRules";

export interface MicrophonePickerProps {
  microphones: MicrophoneOption[];
  selectedMicId: string;
  onChange: (deviceId: string) => void;
}

export default function MicrophonePicker({
  microphones,
  selectedMicId,
  onChange,
}: MicrophonePickerProps): ReactElement {
  return (
    <div id="microphone-select" className="min-w-0 w-full">
      <FieldSelect
        aria-label="Microphone in use"
        triggerMinWidth="100%"
        triggerMaxWidth="100%"
        items={microphones.map((device) => ({
          value: device.deviceId,
          label: formatMicrophoneLabel(device),
        }))}
        value={selectedMicId}
        onChange={(value) => {
          if (value) {
            onChange(value);
          }
        }}
      />
    </div>
  );
}
